import produce, { Draft } from 'immer';

import {
    PHRASES_SELECTOR_CHANGE_REFINE_PHRASE,
    PHRASES_SELECTOR_GET_PHRASE_STATS,
    PHRASES_SELECTOR_GET_REFINE_WORDS,
    PHRASES_SELECTOR_SET_PHRASE_INFO,
    PHRASES_SELECTOR_SET_PHRASE_STATS,
    PHRASES_SELECTOR_SET_REFINE_PHRASE_SHOWS_ERROR,
    PHRASES_SELECTOR_SET_REFINE_PHRASES_ERROR,
    PHRASES_SELECTOR_SET_REFINE_WORDS,
    PhrasesSelectorRefinementsAction
} from '../../actions/phrases-selector/refinements';
import { PhrasesSelectorRefinements, PhrasesSelectorState } from '../../typings/phrases';

export const getDefaultRefinementsState = (): PhrasesSelectorRefinements => {
    return {
        isPhrasesLoading: false,
        isPhraseShowsLoading: false,
        refineWords: [],
        phrase: '',
        hasMoreRefineWords: true,
        phraseShowsPrediction: 0,
        phrasesError: '',
        phraseShowsError: ''
    };
};

export const phrasesSelectorRefinementsReducer = (
    state: PhrasesSelectorState,
    action: PhrasesSelectorRefinementsAction
): PhrasesSelectorState => {
    return produce(state, (draftState: Draft<PhrasesSelectorState>) => {
        switch (action.type) {
            case PHRASES_SELECTOR_GET_REFINE_WORDS:
                draftState.refinements.isPhrasesLoading = true;
                return;
            case PHRASES_SELECTOR_SET_REFINE_WORDS:
                const { hasMore, words } = action;
                draftState.refinements.hasMoreRefineWords = hasMore;
                draftState.refinements.refineWords.push(...words);
                draftState.refinements.isPhrasesLoading = false;
                return;
            case PHRASES_SELECTOR_GET_PHRASE_STATS:
                draftState.refinements.isPhraseShowsLoading = true;
                draftState.refinements.phraseShowsError = '';
                return;
            case PHRASES_SELECTOR_SET_PHRASE_STATS:
                draftState.refinements.isPhraseShowsLoading = false;
                draftState.refinements.phraseShowsPrediction = action.shows;
                return;
            case PHRASES_SELECTOR_CHANGE_REFINE_PHRASE:
                draftState.refinements.phrase = action.phrase;
                return;
            case PHRASES_SELECTOR_SET_PHRASE_INFO:
                draftState.refinements = getDefaultRefinementsState();
                draftState.refinements.phrase = action.phrase;
                draftState.refinements.phraseShowsPrediction = action.shows;
                return;
            case PHRASES_SELECTOR_SET_REFINE_PHRASES_ERROR:
                draftState.refinements.isPhrasesLoading = false;
                draftState.refinements.phrasesError = action.message;
                return;
            case PHRASES_SELECTOR_SET_REFINE_PHRASE_SHOWS_ERROR:
                draftState.refinements.isPhraseShowsLoading = false;
                draftState.refinements.phraseShowsError = action.message;
                return;
            default:
                return;
        }
    });
};
